<input clrDate type="date" [(ngModel)]="temp" (ngModelChange)="show()" style="min-width:110px;">

